import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';

const host = window.location.host.startsWith('localhost') ? 'alpha.saagas.ai' : window.location.host;

const api = axios.create({
  baseURL: `https://${host}/api`
});

const generateAuthToken = async () => {
  const authSession = await fetchAuthSession({});
  const authToken = authSession.tokens?.idToken?.toString() as string;
  return authToken;
};

api.interceptors.request.use(
  async config => {
    const authToken = await generateAuthToken();

    config.headers['Authorization'] = `Bearer ${authToken}`;

    return config;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  response => response,
  async error => {
    const requestOptions = error.config;
    const response = error.response;

    console.error(requestOptions, response, 'error is generating form api.interceptors');

    // if (response?.status === 400 && !requestOptions._retry) {
    //   console.debug('Auth token expired, regenerating....');
    //   requestOptions._retry = true;

    //   try {
    //     const authToken = await generateAuthToken();

    //     requestOptions.headers['Authorization'] = `Bearer ${authToken}`;

    //     return api(requestOptions);
    //   } catch (err) {
    //     return Promise.reject(err);
    //   }
    // }


    return Promise.reject(error);
  }
);

export default api;
